import { useMutation, useQueryClient } from 'react-query';
import { ProjectEstimateAssemblyService as peas } from '../api/ProjectEstimateAssemblyService';
import { EstimateTakeoffAssemblies } from '../api/protosCompiled/estimateAssembly/estimateAssembly_pb';
import { useStore } from 'zustand';
import { useUnityBuildStore } from '../stores/store';

export const useCreateProjectEstimateAssemblyMutation = () => {
  const queryClient = useQueryClient();
  const { selectedEstimate } = useStore(useUnityBuildStore);

  const { mutate, mutateAsync } = useMutation(
    (data: EstimateTakeoffAssemblies.AsObject) => {
      return peas.createProjectEstimateAssembly(data);
    },
    {
      onSuccess: () => {
        // Construct the exact query key to invalidate
        const queryKey = ['countedAssemblies', selectedEstimate?.estimateid];

        // Invalidate and refetch
        queryClient.invalidateQueries(queryKey);
      },
      onError: error => {
        console.error('Error creating project estimate assembly', error);
      },
    }
  );

  // Return both mutate and mutateAsync for use in components or other hooks
  return { mutate, mutateAsync };
};

export const useUpdateProjectEstimateAssemblyMutation = () => {
  const queryClient = useQueryClient();
  const { selectedEstimate } = useStore(useUnityBuildStore);

  const { mutate, mutateAsync } = useMutation(
    (data: EstimateTakeoffAssemblies.AsObject) => {
      return peas.updateProjectEstimateAssembly(data);
    },
    {
      onSuccess: () => {
        const queryKey = ['countedAssemblies', selectedEstimate?.estimateid];
        queryClient.invalidateQueries(queryKey);
      },
      onError: error => {
        console.error('Error updating project estimate assembly', error);
      },
    }
  );

  return { mutate, mutateAsync };
};

export const useDeleteProjectEstimateAssemblyMutation = () => {
  // Destructure mutate and mutateAsync from the useMutation return value
  const { mutate, mutateAsync } = useMutation(
    (assemblyId: string) => {
      return peas.deleteEstimateAssembly(assemblyId);
    },
    {
      // Remove the onSuccess callback as we're now handling optimistic updates ourselves
      onError: error => {
        console.error('Error deleting project estimate assembly', error);
      },
    }
  );

  // Return both mutate and mutateAsync for flexible usage outside
  return { mutate, mutateAsync };
};
